/* eslint-disable */

import { useRef, useState } from 'react';
import './incorrect-quotes-generator.css';
import icon from "./iconoutline.png";
import prompts from './prompts.json';

function IncorrectQuotes() {
  const [darkmode, setDarkMode] = useState(false)
  const [peopleNum, setPeopleNum] = useState(1)
  const peopleNumRef = useRef()
  const swapper = useRef(false)
  const yes = document.querySelector(':root')
  // let decoder

  const [lastPrompt, setLastPrompt] = useState(-1)
  const [creditText, setCreditText] = useState("???")
  const [creditLink, setCreditLink] = useState("")

  // https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
  const shuffleArr = (a,b,c,d) => { //array, placeholder, placeholder, placeholder
    c=a.length; while(c)b=Math.random()*c--|0,d=a[c],a[c]=a[b],a[b]=d
  }

  const setPeople = (set) => {
		setLastPrompt(-1)
    set = parseInt(set)
    peopleNumRef.current.value = Math.min(Math.max(set, 1), prompts.values.length)
    setPeopleNum(peopleNumRef.current.value)
  }

  // https://stackoverflow.com/questions/1637275/simple-html-sanitizer-in-javascript
  // https://randyperkins2k.medium.com/writing-a-simple-markdown-parser-using-javascript-1f2e9449a558
  const safemarkdown = (fromString) => {
    const toHTML = fromString
      // .replace(/^### (.*$)/gim, '<h3>$1</h3>') // h3 tag
      // .replace(/^## (.*$)/gim, '<h2>$1</h2>') // h2 tag
      // .replace(/^# (.*$)/gim, '<h1>$1</h1>') // h1 tag
      // .replace(/<b>/g, '**')
      // .replace(/<\/b>/g, '**')
      // .replace(/<i>/g, '*')
      // .replace(/<\/i>/g, '*') ^(?!hede).*$
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
      .replace(/(?<!\\)\*\*(?!\\)(.*)(?<!\\)\*\*/gim, '<b>$1</b>') // strikethrough text
      .replace(/(?<!\\)\~\~(?!\\)(.*)(?<!\\)\~\~/gim, '<s>$1</s>') // bold text
      .replace(/(?<!\\)\*(.*)(?<!\\)\*/gim, '<i>$1</i>') // italic text
      .replace(/(?<!\\)\_(.*)(?<!\\)\_/gim, function(match) { return match.toLowerCase().substring(1, match.length-1); }) // format lower
      .replace(/(?<!\\)\`(.*)(?<!\\)\`/gim, function(match) { return match.toUpperCase().substring(1, match.length-1); }) // format upper
      .replace(/\\\*/g, '\*') // escaped asterisk??
    return toHTML
  }

  const onButtonClick = () => {
		let index = Math.round(Math.random() * (prompts.values[peopleNum-1].length - (lastPrompt === -1 ? 0.5 : 1.5)))
		if (index >= lastPrompt && lastPrompt !== -1)
			index = (index + 1) % prompts.values[peopleNum-1].length
    const prompt = prompts.values[peopleNum-1][index]
		setLastPrompt(index)

    if (prompt == null) {
      document.getElementById('promptText').innerHTML = "Oops! There doesn't seem to be any prompts for these amount of characters."
      setCreditText('???')
      setCreditLink('')
      return
    }

    let text = ""
		if (typeof prompt.lines !== "string") {
			prompt.lines.forEach((value, index)=>{
				if (value.length > 0 && value.length < 3) {
					if (value.length === 1)
						text = text.concat(value[0])
					else
						text = text.concat("**", value[0], "**: ", value[1])
					if (index !== prompt.lines.length)
						text = text.concat("\n")
				}
			})
		} else {
			text = prompt.lines
		}

    let reindex = []
    for (let i = 1; i <= peopleNum; i++) { reindex.push(i) }
    swapper.current.checked && shuffleArr(reindex)
    for (let i = 0; i <= peopleNum - 1; i++) {
      text = text.replace(new RegExp(`%${i+1}`, 'g'),
        document.getElementById(`person-${reindex[i]}`).value || `Person ${'ABCDEFGHIJKLMNOPQRSTUIVWXYZ'[reindex[i]-1]}`)
    }
    document.getElementById('promptText').innerHTML = safemarkdown(text)

    if (prompt.credit || prompt.link) {
      setCreditText(prompt.credit)
      setCreditLink(prompt.link)
    } else {
      setCreditText('???')
      setCreditLink('')
    }
  }

  return (
    <div id="Paige">
      <div id="header">
        <h1>Incorrect Quotes Generator</h1>
      </div>
      <hr/>
      <div id="stuffs">
        <img src={icon} id="icon" alt="Hi!"/>
        <p>
          {"Number of characters: "}
          <button className="peopleNum" onClick={()=>setPeople(parseInt(peopleNum)+1)}>+</button>
          <input className="peopleNum" ref={peopleNumRef} placeholder={peopleNum} onChange={()=>{
            const urhgh = peopleNumRef.current.value.replace(/[^0-9]+/g, '')
            urhgh && setPeople(urhgh)}} style={{"border": "2px solid var(--text)"}}/>
          <button className="peopleNum" onClick={()=>setPeople(peopleNum-1)}>-</button>
        </p>
        <span style={{"font-family": "Arial, Helvetica, sans-serif", "font-size": "15.5px"}}>Dark Mode </span>
        <input id="darkmode" onChange={() => {
          if (!darkmode) {
            yes.style.setProperty('--background', 'black');
            yes.style.setProperty('--text', 'white');
            yes.style.setProperty('--invert', 1);
          } else {
            yes.style.setProperty('--background', 'white');
            yes.style.setProperty('--text', 'black');
            yes.style.setProperty('--invert', 0);
          }
          setDarkMode(!darkmode)
        }} type="checkbox"/> {" "}
        {prompts.values.map((value, index)=>{
          return <><input key={index} className="peopleNames" id={`person-${index+1}`} type="text"
            placeholder={`Person ${'ABCDEFGHIJKLMNOPQRSTUIVWXYZ'[index]}`} style={index>=peopleNum?{"background-color": "#80808060"}:{}}/> </>
        })}
        <input id="swapper" ref={swapper} type="checkbox"/>
        <span style={{"font-family": "Arial, Helvetica, sans-serif", "font-size": "15.5px"}}> Randomly Swap</span>
        <p>
        <button onClick={()=>onButtonClick()}>Generate!</button> {" "}
        {/* <label class="switch" id="randomize"> <input type="checkbox"/> <span class="slider"/> </label> */}
        </p>
      </div>
      <hr/>
      <div className="unprompted">
        <b>Your prompt:</b>
        <p className='notabpls'>
          <span id="promptText">Generate a prompt first!</span>
          <div id="creditNotDue"> <a href={creditLink}>{creditText}</a> </div>
        </p>
      </div>
      <hr/>
      <div className="unprompted" style={{"text-align": "center"}}>
        <p>
          Hey! Thanks for checking this out. I hope you have fun!<br/>
          This is based off on <a href="https://incorrect-quotes-generator.neocities.org/">ScatterPatter's own Incorrect Quotes Generator</a>, 
          with some prompts taken from there directly!<br/>
          I don't come up with the most of these -- 
          I put where I got them from <i>{"(probably not where they originated, though) "}</i>
          in the bottom-right corner of the prompt box.<br/>
        </p>
        <p>
					Amount of prompts so far:
          {prompts.values.map((value, index)=>{
            	return <><br/>{index + 1} Character{index>0&&"s"} - {value.length}</>
          })}
				</p>
      </div>
    </div>
  );
}

export default IncorrectQuotes;